"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var react_redux_1 = require("react-redux");
var react_intl_1 = require("react-intl");
var styled_components_1 = __importStar(require("styled-components"));
var components_1 = require("components");
var ActionTypes_1 = require("../ActionTypes");
var ScreenshotManager_1 = require("../ScreenshotManager");
var utils_1 = require("../utils");
var moment_1 = __importDefault(require("moment"));
var ToastContainer_1 = __importDefault(require("./ToastContainer"));
var ShareDialog_1 = __importDefault(require("./ShareDialog"));
var Dialog = styled_components_1.default(components_1.MessageDialog)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t\t\n\t@media ", " {\n\t\twidth: 90%;\n\t\theight: 70%;\n\t}\n\t@media ", " {\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tmax-width: unset;\n\t\tmax-height: unset;\n\t\t/*margin: 0;*/\n\t}\n"], ["\n\t\t\n\t@media ", " {\n\t\twidth: 90%;\n\t\theight: 70%;\n\t}\n\t@media ", " {\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tmax-width: unset;\n\t\tmax-height: unset;\n\t\t/*margin: 0;*/\n\t}\n"])), function (props) { return props.theme.breakpoints.desktop; }, function (props) { return props.theme.breakpoints.fullScreenStream; });
var Image = styled_components_1.default.img(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\theight: 100%;\n\twidth: 100%;\n\tobject-fit: ", ";\n\tbackground-color: black;\n\tz-index: 1;\n"], ["\n\theight: 100%;\n\twidth: 100%;\n\tobject-fit: ", ";\n\tbackground-color: black;\n\tz-index: 1;\n"])), function (props) { return props.selected ? "contain" : "cover"; });
var GalleryItem = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tposition: ", ";\n\twidth: 100%;\n\theight: 100%;\n\n\tleft: 0;\n\ttop: 0;\n\tright: 0;\n\tbottom: 0;\n\tz-index: ", ";\n\n\t&:hover>div {\n\t\tvisibility: visible;\n\t}\n\t\n\t", "\n\n\t", ";\n\n\t", ";\n"], ["\n\tposition: ", ";\n\twidth: 100%;\n\theight: 100%;\n\n\tleft: 0;\n\ttop: 0;\n\tright: 0;\n\tbottom: 0;\n\tz-index: ", ";\n\n\t&:hover>div {\n\t\tvisibility: visible;\n\t}\n\t\n\t", "\n\n\t", ";\n\n\t", ";\n"])), function (props) { return props.selected ? "fixed" : "relative"; }, function (props) { return props.selected ? "1" : "0"; }, function (props) { return props.selected && "&>div{ visibility: visible; }"; }, function (props) { return !props.selected && props.theme.layout.focusAccent; }, function (props) { return props.selected && 'cursor: initial'; });
var DetailButton = styled_components_1.default(components_1.IconButton)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\t", "\n"], ["\n\t", "\n"])), function (props) { return props.theme.gallery.focused.options; });
var CloseButton = styled_components_1.default(components_1.IconButton)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\t", "\n\t\n"], ["\n\t", "\n\t\n"])), function (props) { return props.theme.gallery.focused.close; });
var NavButs = styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n\t", "\n"], ["\n\t", "\n"])), function (props) { return props.theme.gallery.focused.navGroup; });
var NavBut = styled_components_1.default(components_1.IconButton)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n\t", "\n"], ["\n\t", "\n"])), function (props) { return props.theme.gallery.focused.nav; });
var Menu = styled_components_1.default.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n\tposition: absolute;\n\ttop: ", ";\n\tright: ", ";\n\n\tfloat: right;\n\t\n\tvisibility: hidden;\n\t@media ", " {\n\t\tvisibility: visible;\n\t\ttop: 12px;\n\t\tright: 12px;\n\t}\n"], ["\n\tposition: absolute;\n\ttop: ", ";\n\tright: ", ";\n\n\tfloat: right;\n\t\n\tvisibility: hidden;\n\t@media ", " {\n\t\tvisibility: visible;\n\t\ttop: 12px;\n\t\tright: 12px;\n\t}\n"])), function (props) { return props.selected ? "36px" : "14px"; }, function (props) { return props.selected ? "36px" : "14px"; }, function (props) { return props.theme.breakpoints.S; });
var ToastDiv = styled_components_1.default.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n\tposition: absolute;\n\tbottom: 0;\n\tright: 0;\n\theight: 30%;\n\tz-index: 50;\n\tpointer-events: none;\n\tcolor: black;\n\tleft: -30px;\n\n\t@media ", "{\n\t\tleft: -12px;\n\t}\n"], ["\n\tposition: absolute;\n\tbottom: 0;\n\tright: 0;\n\theight: 30%;\n\tz-index: 50;\n\tpointer-events: none;\n\tcolor: black;\n\tleft: -30px;\n\n\t@media ", "{\n\t\tleft: -12px;\n\t}\n"])), function (props) { return props.theme.breakpoints.S; });
var DialogID = "Gallery";
var Gallery = /** @class */ (function (_super) {
    __extends(Gallery, _super);
    function Gallery(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            selected: "",
            pendingDelete: null,
            shareScreenshot: null
        };
        // strip out from the results of the enumeration any image currently pending delete
        _this.enumerateScreenshots = function (start, max) {
            return new Promise(function (resolve) {
                ScreenshotManager_1.EnumerateScreenshots(start, max).then(function (shots) {
                    if (shots.length === 0 && _this.props.screenshots > 0 && _this.retryCounter < 5) {
                        ++_this.retryCounter;
                        _this.enumerateScreenshots(start, max).then(resolve);
                    }
                    else {
                        _this.retryCounter = 0;
                        if (_this.state.pendingDelete !== null) {
                            var pendingId_1 = _this.state.pendingDelete ? _this.state.pendingDelete.uuid : "-1";
                            resolve(shots.filter(function (shot) { return shot.uuid !== pendingId_1; }));
                        }
                        else {
                            resolve(shots);
                        }
                    }
                }).catch(function (reason) {
                    _this.retryCounter = 0;
                    console.log("Was unable to enumerate shots?", reason);
                });
            });
        };
        _this.reallyDelete = function (toDelete, newPendingDelete) {
            if (toDelete) {
                ScreenshotManager_1.DeleteScreenshot(toDelete).then(function () {
                    _this.setState({ selected: "", pendingDelete: newPendingDelete || null });
                });
            }
        };
        _this.undoDelete = function () {
            if (_this.state.pendingDelete !== null) {
                var summary = {
                    action: "cancel",
                    modalOnly: true
                };
                _this.props.notifyRestoreScreenshot();
                _this.props.addToast(summary);
                _this.setState({
                    pendingDelete: null
                });
            }
        };
        _this.retryCounter = 0;
        _this.dialogRoot = null;
        return _this;
    }
    Gallery.prototype.componentWillUnmount = function () {
        if (this.state.pendingDelete) {
            ScreenshotManager_1.DeleteScreenshot(this.state.pendingDelete);
        }
    };
    Gallery.prototype.render = function () {
        var _this = this;
        var s = function (id, defaultStr, params) {
            return utils_1.formatMessage(_this.props.intl, { id: id, defaultMessage: defaultStr ? defaultStr : id }, params ? params : {});
        };
        var formatText = function (id, defaultStr, params) {
            return utils_1.formatMessage(_this.props.intl, { id: id, defaultMessage: defaultStr ? defaultStr : id }, __assign(__assign({}, params), { b: function (msg) { return (react_1.default.createElement("b", { key: Math.random() }, msg)); }, br: function () { return (react_1.default.createElement("br", { key: "br_" + Math.random() })); } }));
        };
        var self = this;
        var title = s("gallery.title", "Snapshot Gallery");
        var close = s("general.close", "Close");
        var download = s("gallery.download", "Download");
        var share = s("gallery.share", "Share");
        var deleteStr = s("gallery.delete", "Delete");
        var icons = this.props.theme.svgs;
        var emptyHead = s("gallery.emptyHead", "Snapshot Gallery is currently empty.");
        var emptyContent = formatText("gallery.subContent", "Start taking captures of your awesome custom ride to fill up your gallery.<br/><b>Download</b> &amp; <b>Share</b> your amazing content with friends.");
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Dialog, { altTheme: true, title: title, onClose: this.props.onClose, closeTooltip: close, id: DialogID },
                react_1.default.createElement(ToastDiv, { "data-automationid": "toast_wrapper" },
                    react_1.default.createElement(ToastContainer_1.default, { modal: true })),
                react_1.default.createElement(components_1.Gallery, { Id: "gallery_view", maxVisibleRows: 2, maxVisibleColumns: 4, desiredAspect: 1, count: this.props.screenshots, getItems: this.enumerateScreenshots, emptyIcon: icons.icon_empty_gallery, emptyTextHeading: emptyHead, emptyTextContent: emptyContent, item: {
                        type: function (props) {
                            var selected = props.item.uuid === _this.state.selected;
                            var downloadImage = function () {
                                var title = props.item.title;
                                if (utils_1.canUseFlyCam() && props.item.config.unit !== undefined) {
                                    title = props.item.config.unit.sku + "_" + title + "_";
                                    if (props.item.config.shotid !== undefined) {
                                        var idparts = props.item.config.shotid.split("-");
                                        var idstub = "badid";
                                        if (idparts.length > 0) {
                                            idstub = idparts[idparts.length - 1];
                                        }
                                        title = title + idstub;
                                    }
                                    else {
                                        title = title + moment_1.default().format("MMDDYY_HHmmss");
                                    }
                                }
                                else {
                                    var params = {
                                        Package: function () { return props.item.title; },
                                        Date: function () { return new Date(props.item.timestamp).toLocaleDateString(); },
                                        Time: function () { return new Date(props.item.timestamp).toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' }); }
                                    };
                                    var fmtTitle = self.props.intl.formatMessage({ id: "gallery.filename", defaultMessage: "Custom <Package/> <Date/> at <Time/>" }, params);
                                    if (typeof (fmtTitle) === "string") {
                                        title = fmtTitle;
                                    }
                                    else {
                                        title = fmtTitle.join("");
                                    }
                                }
                                var url = props.item.image;
                                var name = title.replace(/[//]/g, "-").replace(/:/g, ".") + "." + props.item.format;
                                var a = document.createElement('a');
                                document.body.appendChild(a);
                                a.href = url;
                                a.download = name;
                                a.click();
                                document.body.removeChild(a);
                            };
                            var downloadImageInfo = function () {
                                downloadImage();
                                if (utils_1.copyTextToClipboard(JSON.stringify(props.item.config))) {
                                    alert("Copied shot metadata to the clipboard!");
                                }
                            };
                            var renderedItem = null;
                            if ((_this.state.selected.length === 0 || selected) && props.item.image) {
                                var deleteCorruptScreenshot = function () {
                                    console.warn("Deleting corrupted screenshot", props.item);
                                    ScreenshotManager_1.DeleteScreenshot(props.item);
                                    _this.props.notifyDeleteScreenshot();
                                };
                                renderedItem = (react_1.default.createElement(GalleryItem, { onClick: selected ? undefined : function () { _this.setState({ selected: props.item.uuid }); }, selected: selected },
                                    react_1.default.createElement(Image, { src: props.item.image, selected: selected, alt: new Date(props.item.timestamp).toLocaleString(), onError: deleteCorruptScreenshot }),
                                    react_1.default.createElement(Menu, { selected: selected },
                                        react_1.default.createElement(DetailButton, { name: "Show options", small: true, icon: _this.props.theme.svgs.actions_dots, automationId: "showphotooptions" },
                                            !window.zlurlparams.nosharing &&
                                                react_1.default.createElement(components_1.ContextOption, { icon: icons.icon_share, onClick: function () { _this.setState({ shareScreenshot: props.item }); }, text: share, automationId: "takephoto" }),
                                            react_1.default.createElement(components_1.ContextOption, { icon: icons.icon_download, onClick: downloadImage, text: download, automationId: "downloadphoto" }),
                                            utils_1.canUseFlyCam() &&
                                                react_1.default.createElement(components_1.ContextOption, { icon: icons.icon_download, onClick: downloadImageInfo, text: "D/L and copy info", automationId: "downloadphoto2" }),
                                            react_1.default.createElement(components_1.ContextOption, { icon: icons.icon_delete, onClick: function () {
                                                    // setting this to true restores the instant delete behaviour
                                                    var instantDelete = false;
                                                    _this.props.notifyDeleteScreenshot();
                                                    if (_this.state.pendingDelete !== null) {
                                                        _this.reallyDelete(_this.state.pendingDelete, props.item);
                                                    }
                                                    else {
                                                        var newState = __assign(__assign({}, _this.state), { selected: "" });
                                                        if (instantDelete) {
                                                            _this.reallyDelete(props.item);
                                                        }
                                                        else {
                                                            newState.pendingDelete = props.item;
                                                        }
                                                        _this.setState(newState);
                                                    }
                                                    if (!instantDelete) {
                                                        var summary = {
                                                            action: "delete",
                                                            modalOnly: true,
                                                            onClick: _this.undoDelete
                                                        };
                                                        _this.props.addToast(summary);
                                                    }
                                                }, text: deleteStr, automationId: "deletephoto" }))),
                                    selected &&
                                        react_1.default.createElement("div", null,
                                            react_1.default.createElement(CloseButton, { icon: icons.arrow_left, name: "Show options", small: true, onClick: function () { return _this.setState({ selected: "" }); }, automationId: "goback" }),
                                            _this.props.screenshots > 1 && /* need to work out if/how this will work with the buffering */
                                                react_1.default.createElement(NavButs, null,
                                                    react_1.default.createElement(NavBut, { name: "prev", icon: icons.arrow_left, small: true, onClick: function () { _this.setState({ selected: props.prev.uuid }); }, automationId: "prevscreenshot" }),
                                                    react_1.default.createElement(NavBut, { name: "next", icon: icons.arrow_right, small: true, onClick: function () { _this.setState({ selected: props.next.uuid }); }, automationId: "nextscreenshot" })))));
                            }
                            if (selected) {
                                if (!_this.dialogRoot) {
                                    _this.dialogRoot = document.getElementById(DialogID);
                                    if (!_this.dialogRoot) {
                                        return renderedItem;
                                    }
                                }
                                return react_dom_1.default.createPortal(renderedItem, _this.dialogRoot);
                            }
                            return renderedItem;
                        }
                    } })),
            this.state.shareScreenshot &&
                react_1.default.createElement(ShareDialog_1.default, { onClose: function () { return _this.setState({ shareScreenshot: null }); }, image: this.state.shareScreenshot.image, screenshot: true })));
    };
    return Gallery;
}(react_1.Component));
var MapStoreToProps = function (store /*, ownProps: any*/) {
    return {
        screenshots: store.UI.screenshots
    };
};
var DeleteShot = function () { return ({
    type: ActionTypes_1.DELETE_SCREENSHOT
}); };
var RestoreShot = function () { return ({
    type: ActionTypes_1.RESTORE_SCREENSHOT
}); };
var AddToast = function (summary) { return ({
    type: ActionTypes_1.ADD_TOAST,
    summary: summary
}); };
exports.default = react_redux_1.connect(MapStoreToProps, {
    notifyDeleteScreenshot: DeleteShot,
    notifyRestoreScreenshot: RestoreShot,
    addToast: AddToast
})(styled_components_1.withTheme(react_intl_1.injectIntl(Gallery)));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;
//# sourceMappingURL=Gallery.js.map